module.exports = __webpack_public_path__ + "img/badge-firefox.53dbda65.png";